import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import { getEntryStatusColor } from "../common/VisualElementsHelper";
import { AppEntryRepository } from "../repositories/AppEntryRepository";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { Enumerations } from "../../config/Enumerations";
import { FiPlusCircle } from "react-icons/fi";
import { MdHistory, MdPayment } from "react-icons/md";
import { MdCancel } from "react-icons/md";
import { MdSend } from "react-icons/md";
import { MdEditNote } from "react-icons/md";
import { MdAssignmentTurnedIn } from "react-icons/md";
import { MdNotes } from "react-icons/md";
import { MdVisibility } from "react-icons/md";
import { MdGavel } from "react-icons/md";
import { MdDraw } from "react-icons/md";
import { MdCheckCircle } from "react-icons/md";
import { MdCancelPresentation } from "react-icons/md";
import { TbProgressCheck } from "react-icons/tb";
import AddCorrectionDialog from "./AddCorrectionDialog";
import { AppEntryAuditLog } from "../audit/AppEntryAuditLog";

const statusIcons = {
  NEW: <FiPlusCircle />,
  PENDING_PAYMENT: <MdPayment />,
  SUBMITTED: <MdSend />,
  REJECTED: <MdCancel />,
  PROCESSING: <TbProgressCheck />,
  CORRECTION: <MdEditNote />,
  FOR_APPROVAL: <MdAssignmentTurnedIn />,
  ADDITIONAL_CORRECTION: <MdNotes />,
  INSTITUTIONS_REVIEW: <MdVisibility />,
  INSTITUTION_DECISION: <MdGavel />,
  FINAL_DECISION_SIGNING: <MdDraw />,
  DONE: <MdCheckCircle />,
  CANCELED: <MdCancelPresentation />,
};

export default function EntryStatusesPanel({ appEntry, setAppEntry }) {
  const theme = useTheme();
  const auth = useSelector((state) => state.auth);
  const [availableStatuses, setAvailableStatuses] = useState([]);
  const [openCorrectionDialog, setOpenCorrectionDialog] = useState(false);
  const [auditLogOpen, setAuditLogOpen] = useState();

  useEffect(() => {
    if (appEntry) {
      getAvailableStatuses();
    }
  }, [appEntry]);

  const getAvailableStatuses = () => {
    AppEntryRepository.getAvailableStatuses(appEntry?.status)
      .then((res) => {
        setAvailableStatuses(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const rejectForInvalidPayment = () => {
    AppEntryRepository.rejectForInvalidPayment(appEntry?.id)
      .then((res) => {
        setAppEntry(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const submitForApproval = () => {
    AppEntryRepository.submitForApproval(appEntry?.id)
      .then((res) => {
        setAppEntry(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <Box
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          <Button
            disabled
            sx={{
              cursor: "default",
              display: "inline-flex",
              backgroundColor: getEntryStatusColor(appEntry?.status),
              color: "#fff",
              borderRadius: 0,
              textTransform: "none",
              fontSize: 15,
              fontFamily: "Inter-Regular",
              justifyContent: "center",
              alignItems: "center",
              "&:hover": {
                backgroundColor: getEntryStatusColor(appEntry?.status),
              },
              "&.Mui-disabled": {
                color: "white",
                opacity: 1,
              },
            }}
          >
            Статус: {Enumerations.AppEntryStatus[appEntry?.status]}
          </Button>
          {appEntry?.archiveNumber && (
            <div className="entry-details-block">
              <Typography variant="caption" display="block">
                Архивски број
              </Typography>
              <Typography className="inter-medium">
                {appEntry?.archiveNumber}
              </Typography>
            </div>
          )}
          {(auth?.userData?.roles?.includes("ROLE_SUPER_ADMIN") ||
            auth?.userData?.roles?.includes("ROLE_MT_REVIEWER")) && (
            <Button
              onClick={() => setAuditLogOpen(true)}
              color="error"
              startIcon={<MdHistory />}
              variant="contained"
              style={{ marginRight: "auto" }}
            >
              Историјат
            </Button>
          )}
          {auditLogOpen && (
            <AppEntryAuditLog
              appEntryId={appEntry?.id}
              handleClose={() => setAuditLogOpen()}
            />
          )}
        </Box>
        <Box style={{ display: "flex", gap: "5px" }}>
          {availableStatuses.length > 0 &&
            availableStatuses.map((status) => {
              const permissionToClick =
                (status === "SUBMITTED" &&
                  auth?.userData?.roles?.includes("ROLE_MT_ARCHIVER")) ||
                (status === "REJECTED" &&
                  auth?.userData?.roles?.includes("ROLE_MT_ARCHIVER")) ||
                ((status === "FOR_APPROVAL" || status === "CORRECTION") &&
                  auth?.userData?.roles?.includes("ROLE_MT_REVIEWER")) ||
                (status === "FOR_APPROVAL" &&
                  auth?.userData?.roles?.includes("ROLE_MT_REVIEWER"));

              return (
                <Button
                  key={status}
                  variant="outlined"
                  size="large"
                  // disabled={!permissionToClick}
                  sx={{
                    border: "1px solid #e1e1e1",
                    display: "inline-flex",
                    color: theme.palette.secondary.main,
                    borderRadius: 0,
                    textTransform: "none",
                    fontSize: 15,
                    fontFamily: "Inter-Regular",
                    justifyContent: "center",
                    alignItems: "center",
                    "&:hover": {
                      backgroundColor: "#eff5fb",
                      border: "1px solid #eff5fb",
                      color: theme.palette.secondary.main,
                    },
                    "&.Mui-disabled": {
                      color: theme.palette.secondary.main,
                      opacity: 1,
                    },
                  }}
                  endIcon={
                    statusIcons[status]
                      ? React.cloneElement(statusIcons[status], {
                          fontSize: 18,
                          color: getEntryStatusColor(status),
                        })
                      : null
                  }
                  onClick={() => {
                    if (!permissionToClick) return;
                    if (permissionToClick && status == "REJECTED") {
                      rejectForInvalidPayment();
                    }
                    if (status === "CORRECTION") {
                      setOpenCorrectionDialog(true);
                    }
                    if (status === "FOR_APPROVAL") {
                      submitForApproval();
                    }
                  }}
                >
                  {Enumerations.AppEntryStatusActions[status]}
                </Button>
              );
            })}
        </Box>
      </Grid>
      {openCorrectionDialog && (
        <AddCorrectionDialog
          openCorrectionDialog={openCorrectionDialog}
          setOpenCorrectionDialog={setOpenCorrectionDialog}
          appEntry={appEntry}
          setAppEntry={setAppEntry}
        />
      )}
    </React.Fragment>
  );
}
